import React from 'react';

// A simple, reusable modal component
const Modal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    children,
    confirmLabel,
    cancelLabel,
    isConfirmDisabled = false,
    maxWidth = 'max-w-lg'
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        // Overlay: covers the entire screen, with a semi-transparent background
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            {/* Modal Panel: the main content of the modal */}
            <div className={`bg-white p-6 rounded-lg shadow-xl w-full ${maxWidth} mx-4`}>
                <h2 className="text-xl font-bold mb-4">{title}</h2>
                <div className="mb-6">
                    {children}
                </div>
                {/* Action Buttons */}
                <div className="flex justify-end gap-4">
                    {onConfirm ? (
                        <>
                            <button
                                onClick={onClose} // The function to call when the 'Cancel' button is clicked
                                className="py-2 px-4 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
                            >
                                {cancelLabel || 'いいえ'}
                            </button>
                            <button
                                onClick={onConfirm} // The function to call when the 'Confirm' button is clicked
                                disabled={isConfirmDisabled}
                                className="py-2 px-4 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {confirmLabel || 'はい'}
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={onClose}
                            className="py-2 px-4 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                        >
                            {confirmLabel || cancelLabel || 'OK'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Modal;
